export default __webpack_public_path__ + "static/media/dropdown_profile_icon.a27969be.svg";